import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

import { useFetchKeywordGroups } from '@/hooks/queries/keywords';
import { Evaluation } from '@/models/evaluations';
import { QueryToken, queryToTokens } from '@/utils/evaluations/query';

const tokenSx = (token: QueryToken): object => {
  switch (token.type) {
    case 'operator':
      return {
        color: token.text === 'OR' ? 'success.main' : '#574DFF',
        fontWeight: 600
      };
    case 'negatedOperator':
    case 'negation':
      return { color: 'error.main', fontWeight: 600 };
    case 'groupParen':
      return { color: 'warning.main', fontWeight: 600 };
    case 'paren':
      return { color: 'text.secondary' };
    default:
      return {};
  }
};

interface QueryDrawerProps {
  open: boolean;
  onClose: () => void;
  query: Evaluation.Form['keywordQuery'];
}

const QueryDrawer = ({ open, onClose, query }: QueryDrawerProps) => {
  const { data: keywordGroups = [] } = useFetchKeywordGroups({
    keywords: true
  });

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { maxHeight: '60vh', left: '64px', width: `calc(100% - 64px)` }
      }}
    >
      <Box sx={{ p: 3 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography variant="h6">Resulting query</Typography>
          <IconButton size="small" onClick={onClose}>
            <GridCloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-wrap', overflow: 'auto' }}
        >
          {queryToTokens(query, keywordGroups).map((token, i) => (
            <Box key={i} component="span" sx={tokenSx(token)}>
              {token.text}
            </Box>
          ))}
        </Typography>
      </Box>
    </Drawer>
  );
};

export default QueryDrawer;
